/**
 * Initializes any links that should trigger the Drift chat widget
 */
export function initChat() {
  if (typeof drift === 'undefined') {
    return false;
  }

  // Enhance elements with a '[data-open-chat="true"]' to open the drift chat bubble
  drift.on('ready', () => {
    const driftTriggers = [...document.querySelectorAll('[data-open-chat="true"]')];

    // Don't make an XHR request if there are no Drift chat triggers on the page
    if (!driftTriggers.length) {
      return;
    }

    const availabilityEndpoint = document.getElementById('ChatAvailability').dataset.chatEndpoint;
    const xhr = new XMLHttpRequest();

    xhr.overrideMimeType('application/json');
    xhr.open('GET', availabilityEndpoint, true);

    xhr.onload = () => {
      if (xhr.status !== 200) {
        return;
      }

      const response = JSON.parse(xhr.response);
      initChatTriggers(driftTriggers, response.chatAvailable);
    };

    xhr.send(null);
  });

  return false;
}

function initChatTriggers(triggers, chatAvailable) {
  const driftChat = document.querySelector('body > .drift-frame-controller');

  if (!chatAvailable) {
    return;
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const driftPlaybookId = parseInt(trigger.dataset.driftPlaybook, 10);

      event.preventDefault();

      driftChat.classList.add('is-above-modal');
      drift.api.startInteraction({interactionId: driftPlaybookId});
    });

    trigger.classList.add('js-is-initialized');
  });
}
